import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import OrderGrid from "../../compenents/Order/OrderGrid";
import AdminOrderGrid from "../../compenents/Order/AdminOrderGrid";

interface AdminOrdersProps {}

const AdminOrders: React.FunctionComponent<AdminOrdersProps> = (props) => {
  return (
    <>
      <Container maxWidth={false}>
        <AdminOrderGrid></AdminOrderGrid>
      </Container>
    </>
  );
};

export default AdminOrders;
